module.exports = require("ngx-bootstrap/modal");